(function () {
'use strict';

angular.module('hyresgastApp').directive('omniscroller', omniscroller);
angular.module('hyresgastApp').directive('omniscrollbar', omniscrollbar);

function omniscroller() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'components/omniscroller/omniscroller.html',
    scope: {
      active: '<',
    }
  };
}

function omniscrollbar($document, $interval) {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'components/omniscroller/omniscrollbar.html',
    scope: {
      scopeId: '=?',
    },
    link: function ($scope, $element) {
      $scope.isSet = false;
      $interval(function () {
        if ($scope.isSet) {
          $scope.contentWidth = $scope.contentsEl[0].scrollWidth;
          return;
        }

        let prefix = ($scope.scopeId && $scope.scopeId.length) ? `#${$scope.scopeId} > ` : '';

        $scope.scrollbarEl = $element[0].querySelector(prefix + '.omniscroller-scrollbar');
        $scope.contentsEl = $document[0].querySelectorAll(prefix + '.omniscroller-content');

        if ($scope.scrollbarEl && $scope.contentsEl) {
          $scope.scrollbarEl.addEventListener('scroll', function () {
            for (let content of $scope.contentsEl) {
              content.style.transform = `translateX(-${$scope.scrollbarEl.scrollLeft}px)`;
            }
          });

          $scope.isSet = true;
        }
      }, 300);
    }
  };
}
})();